export type DeploymentEnv = 'development' | 'preview' | 'production';

export function resolveDeploymentEnv(
  vercelEnv: string | undefined,
  nodeEnv: string | undefined,
): DeploymentEnv {
  if (vercelEnv === 'preview' || vercelEnv === 'development') return vercelEnv;
  // Any other env on Vercel (production or a custom target like 'staging')
  // deliberately gets unstyled production treatment.
  if (vercelEnv) return 'production';
  // Not on Vercel (local dev, tests, self-hosted builds) — NODE_ENV is all we have.
  return nodeEnv === 'development' ? 'development' : 'production';
}

// Both vars must be spelled out fully — Next.js inlines `process.env.X` into the
// client bundle by static text substitution, so dynamic access returns undefined.
export const DEPLOYMENT_ENV: DeploymentEnv = resolveDeploymentEnv(
  process.env.NEXT_PUBLIC_VERCEL_ENV,
  process.env.NODE_ENV,
);

const FAVICON_HREFS: Record<DeploymentEnv, string> = {
  development: '/favicon-dev.png',
  preview: '/favicon-preview.png',
  production: '/aurium-logo.png',
};

export const FAVICON_HREF = FAVICON_HREFS[DEPLOYMENT_ENV];

const TITLE_PREFIXES: Record<DeploymentEnv, string> = {
  development: '[D] ',
  preview: '[P] ',
  production: '',
};

/** Tab title with the environment marker ([D] dev, [P] preview, none in prod). */
export function tabTitle(title: string): string {
  return `${TITLE_PREFIXES[DEPLOYMENT_ENV]}${title}`;
}
